import { Typography } from 'antd';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { WithTextChange } from 'components/ui/Transitions';
import { TableNumberController } from 'stores/common';
import { formatNumberControllerValue } from 'utils/number';

import { CHANGE_VALUE_TRANSITION_TIME } from '../common';
import { TableControllerProps } from '../types';

import s from './NumberController.module.scss';

const NumberController: React.FC<
  TableControllerProps<TableNumberController>
> = ({ record, className }) => {
  const value = formatNumberControllerValue({
    value: record.controllerValue.value,
    format: record.controllerValue.format,
  });

  if (!value.trim()) {
    return null;
  }

  const isNegative =
    record.controllerValue.value !== null &&
    record.controllerValue.value < 0;

  return (
    <WithTextChange
      className={cn(className, { [s.negative]: isNegative })}
      label={value}
      Wrapper={Typography.Text}
      transitionTime={CHANGE_VALUE_TRANSITION_TIME}
    />
  );
};

export default observer(NumberController);
